"use client";

import Img from '@/components/Img';
import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

// Яндекс.Метрика. Номер счётчика — из общих настроек админки (settings.metrika_id);
// пусто → компонент не рендерится. Хит отправляется при каждой смене маршрута
// (SPA-навигация Next), плюс webvisor/clickmap.
export default function YandexMetrika({ id }: { id: string }) {
  const pathname = usePathname();

  // SPA: авто-хит отключён (defer:true в init), поэтому шлём hit сами на
  // КАЖДОЙ смене маршрута, включая первый рендер. Стаб ym создаём на всякий
  // случай — тогда hit попадёт в очередь ym.a, даже если tag.js ещё не успел
  // загрузиться (иначе можно потерять просмотр посадочной страницы).
  useEffect(() => {
    if (!id) return;
    const w = window as unknown as { ym?: { (...a: unknown[]): void; a?: unknown[] } };
    if (!w.ym) {
      const stub = function (...a: unknown[]) { (stub.a ||= []).push(a); } as { (...a: unknown[]): void; a?: unknown[] };
      w.ym = stub;
    }
    w.ym!(Number(id), "hit", window.location.href);
  }, [pathname, id]);

  if (!id) return null;
  return (
    <>
      <Script id="yandex-metrika" strategy="afterInteractive">{`
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        ym(${Number(id)}, "init", { defer:true, clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true });
      `}</Script>
      <noscript>
        <Img src={`https://mc.yandex.ru/watch/${Number(id)}`} style={{ position: "absolute", left: "-9999px" }} alt="" />
      </noscript>
    </>
  );
}
